/**
 * Sentry bootstrap for the FE. Imported BEFORE App in src/index.tsx so the
 * SDK is initialised before any route renders and any error in the React
 * tree can be captured by the ErrorBoundary at the App root.
 *
 * The DSN is wired via REACT_APP_SENTRY_DSN — CRA inlines any `REACT_APP_*`
 * env var into the build at compile time. When unset (dev, local, no
 * Sentry account), Sentry.init effectively no-ops; no events are sent.
 *
 * Why no replay/session integrations: those add ~50KB minified to every
 * page load. We're prioritising bundle size for the demo — turn them on
 * later if we need session replay for debugging.
 */
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN || '';

if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.NODE_ENV || 'development',
		tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE) || 0.1,
		// Don't send PII (cookies, query params with tokens) to Sentry by default.
		sendDefaultPii: false,
		// Standard browser tracing — captures pageloads, navigations, fetches.
		integrations: [Sentry.browserTracingIntegration()],
		// Drop noisy / actionable-for-no-one errors before sending.
		ignoreErrors: [
			// React error boundary internal noise
			'ResizeObserver loop limit exceeded',
			'Non-Error promise rejection captured',
		],
	});
}

export { Sentry };
